import React, {useEffect, useState } from 'react'
import {
    Box, Button, Grid, TextField, Select, MenuItem, 
    FormControl, InputLabel, InputAdornment, IconButton, Typography, Paper,
    Dialog, DialogActions, DialogTitle, DialogContent
} from '@mui/material'
import buttonStyle from '../../../styles/buttonStyle'
import boxStyle from '../../../styles/boxStyle';
import { useNavigate, useParams } from 'react-router-dom';
import HeaderBox from '../../../components/HeaderBox';
import SearchIcon from '@mui/icons-material/Search';
import ViewListOutlinedIcon from '@mui/icons-material/ViewListOutlined';
import AddLabourTask from '../../../components/estimate/AddLabourTask';
import AddPartsTask from '../../../components/estimate/AddPartsTask';
import ParentLabour from '../../task/ParentLabour';
import { labour } from '../../../data/LabourData';
import { parts } from '../../../data/PartsData';
import FirstChild from '../../task/FirstChild';
import SecondChild from '../../task/SecondChild';
import Cutomer from '../../../components/estimate/Cutomer';
import Vehicle from '../../../components/estimate/Vehicle';
import DateCalander from '../../../components/DateCalander';
import { EnquiryData } from '../../../data/EnquiryData';
import { VehicleData } from '../../../data/VehicleData';

const firstLabourRow = {
    description: "",
    id: 1,
    hrRate: 40,
    hrs: 1,
    actualHr: 1,
    vat: '20.00',
    tradeRate: "",
    amt: "",
    labourId: null
}

const firstPartsRow = {
    description: "",
    id: 1,
    costRate: 45,
    qty: 1,
    markup: 10,
    vat: '20.00',
    trade: "",
    amt: "",
    partsId: null
}


function EstimateTask() {
  
    const navigate = useNavigate()
    const urlParams = useParams()
    const [firstChild, setFirstChild] = useState()
    const [secondChildren, setSecondChildren] = useState()
    const [parentName, setParentName] = useState()
    const [checked, setChecked] = useState([]);
    const [checkedParts, setCheckedParts] = useState([]);
    const [fChild, setFChild] = useState(false)
    const [sChild, setSChild] = useState(false)
    const [customer, setCustomer] = useState(false)
    const [vehicle, setVehicle] = useState(false)
    const [disc, setDisc] = useState(0)
    const [vat, setVat] = useState(20)

    const [open, setOpen] = useState(false);
    const [enquiryDetail, setEnquiryDetail] = useState({ EnquiryNo: 1, EnquiryDate: '', Customer: '',
                                                        Address:'',Street_Name:'',Post_Code:' ',Email :'',Mob_No:'',  
                                                        VehicleModel: '', VehicleNumber:'', enstatus:'' })
    const [vehicleDetail, setVehicleDetail] = React.useState({ id: 1, VRM: '', Make:'', Model:'',Engine: '',Engine_power: '', Vehicle_Description:'', Mfr_Date:'', First_Used:'', Fuel_type:'', Gear_Type: '',Fleet_No: '',
                                                                MOT:'',   MOT_Due:'',   Owner:'', Sale_Date:'',Sale_Dealer:'',});

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setCustomer(false)
        setVehicle(false)
    };

    useEffect(()=>{
        const data = EnquiryData.find((item) => item.EnquiryNo === Number(urlParams.enquiryId))
        if(data){
            setEnquiryDetail(data)
            const vData = VehicleData.find(item => item.VRM === data.VehicleNumber)
            setVehicleDetail(vData)
        }     

    }, [urlParams])

    const handleParent = (id, label) => {
        const newChildren = labour.find(item => item.id === id).children
        setParentName(label)
        setFirstChild(newChildren)
        setFChild(true)
    }
    const handleChild = (id, label) => {
        setFChild(false)
        setSChild(true)
        const newChildren = firstChild.find(item => item.id === id).children
        setParentName(label)
        setSecondChildren(newChildren)
    }

    const handleToggle = (value, item) => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        const currentIndexParts = checkedParts.indexOf(value);
        const newCheckedParts = [...checkedParts];

        if (currentIndex === -1) {
            newChecked.push(value);
            addRow(item)
        } else {
            newChecked.splice(currentIndex, 1);
            deleteRow(value)
        }
        setChecked(newChecked);

        if (currentIndexParts === -1) {
            const partsItem = parts.filter(part => part.pid === value)
            newCheckedParts.push(value);
            addRowParts(partsItem)
        } else {
            newCheckedParts.splice(currentIndexParts, 1);
            deleteRowParts(value, null)
        }
        setCheckedParts(newCheckedParts);
    };

    const handleDelete = (id) => {
        const currentIndex = checked.indexOf(id);
        const newChecked = [...checked];
        newChecked.splice(currentIndex, 1);
        setChecked(newChecked);

        const currentIndexParts = checkedParts.indexOf(id);
        const newCheckedParts = [...checkedParts];
        newCheckedParts.splice(currentIndexParts, 1);
        setCheckedParts(newCheckedParts);
    };

    const [rows, setRows] = useState([]);
    const [rowsPart, setRowsPart] = useState([]);

    const addRow = (field) => {
        // const lastRow = rows[rows.length - 1];
        // // Check if the last row's "name" field is empty or if it's the same as a previously added row
        // if (!lastRow || lastRow[field] === '') {
        //   alert('Please fill in all fields before adding a new row.');
        //   return;
        // }     
        // // Check for duplicate names
        // if (rows.slice(0, rows.length - 1).some((row) => row[field] === lastRow[field])) {
        //   alert('Item already added.');
        //   return;
        // }    
        const newRow = { ...firstLabourRow, id: rows.length + 1, description: field.label, labourId: field.id, amt: firstLabourRow.actualHr * firstLabourRow.hrRate }; // Modify as needed
        setRows([...rows, newRow]);
    };

    const deleteRow = (id) => {
        const updatedRows = rows.filter((row) => row.labourId !== id);

        // After filtering, reassign consecutive IDs to the rows
        const updatedRowsWithConsecutiveIDs = updatedRows.map((row, index) => ({
            ...row,
            id: index + 1,
        }));

        setRows(updatedRowsWithConsecutiveIDs);
        //   else {
        //     // If there's only one row left, reset its ID to 1
        //     setRows([{ id: 1, name: '' }]);
        //   }
    };

    const addRowParts = (partItems) => {
        console.log(partItems);
        // const lastRow = rows[rows.length - 1];
        // // Check if the last row's "name" field is empty or if it's the same as a previously added row
        // if (!lastRow || lastRow[field] === '') {
        //   alert('Please fill in all fields before adding a new row.');
        //   return;
        // }     
        // // Check for duplicate names
        // if (rows.slice(0, rows.length - 1).some((row) => row[field] === lastRow[field])) {
        //   alert('Item already added.');
        //   return;
        // }  
        let currentId = rowsPart.length + 1;
        const modifiedData = partItems.map((item) => ({
            ...firstPartsRow,
            id: currentId++,
            description: item.label,
            partsId: item.pid,
            trade: (firstPartsRow.costRate * (firstPartsRow.markup / 100)) + firstPartsRow.costRate,
            amt: ((firstPartsRow.costRate * (firstPartsRow.markup / 100)) + firstPartsRow.costRate) * firstPartsRow.qty,

        }))
        console.log(modifiedData);
        // const newRow = { ...firstPartsRow, ...modifiedData }; // Modify as needed
        setRowsPart([...rowsPart, ...modifiedData]);
    };

    const deleteRowParts = (id, del) => {
        console.log(id, rowsPart);
        const updatedRows = rowsPart.filter((row) => row.partsId !== id);
        const updatedRowsDel = rowsPart.filter((row) => row.id !== id);

        // After filtering, reassign consecutive IDs to the rows
        const updatedRowsWithConsecutiveIDs = del ? updatedRowsDel.map((row, index) => ({
            ...row,
            id: index + 1,
        })) :
            updatedRows.map((row, index) => ({
                ...row,
                id: index + 1,
            }));

        setRowsPart(updatedRowsWithConsecutiveIDs);
        //   else {
        //     // If there's only one row left, reset its ID to 1
        //     setRows([{ id: 1, name: '' }]);
        //   }
    };

    const calculateTotalAmount = () => {
        const totalLabourAmount = rows.reduce((accumulator, row) => {
            return accumulator + parseFloat(row.amt || 0);
        }, 0);
        const totalPartsAmount = rowsPart.reduce((accumulator, row) => {
            return accumulator + parseFloat(row.amt || 0);
        }, 0);
        //   setLabourTotal(totalLabourAmount)
        //   setPartsTotal(totalPartsAmount)
        return totalLabourAmount + totalPartsAmount;
    };


    const calculateDiscountedAmount = () => {
        const totalAmount = calculateTotalAmount();
        return totalAmount - (totalAmount * (disc / 100));
    };

    const calculateVATAmount = () => {
        const discountedAmount = calculateDiscountedAmount();
        return discountedAmount * (vat / 100);
    };

    const calculateNetTotal = () => {
        const discountedAmount = calculateDiscountedAmount();
        const vatAmount = calculateVATAmount();
        return (discountedAmount + vatAmount);
    };

    return (
      <Box mt={2}>
        <form>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Box sx={boxStyle.root}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={6} md={6} lg={1.5}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Enquiry No"
                      variant="outlined"
                      required
                      name="enquiry No"
                      value={
                        enquiryDetail.EnquiryNo ? enquiryDetail.EnquiryNo : ""
                      }
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={1.6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Estimate Number"
                      variant="outlined"
                      required
                      name="estimateName"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>
                            <IconButton>
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={1.6}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Estimate Date"
                      variant="outlined"
                      required
                      name="estimateDate"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={1.5}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Vehicle Number"
                      variant="outlined"
                      required
                      name="vrn"
                      value={
                        enquiryDetail.VehicleNumber
                          ? enquiryDetail.VehicleNumber
                          : ""
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>
                            <IconButton
                              onClick={() => {
                                setVehicle(true);
                                handleClickOpen();
                              }}
                            >
                              <ViewListOutlinedIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={1.7}>
                    <TextField
                      fullWidth
                      size="small"
                      label="Customer"
                      variant="outlined"
                      required
                      name="customer"
                      value={
                        enquiryDetail.Customer ? enquiryDetail.Customer : ""
                      }
                      InputProps={{
                        endAdornment: (
                          <InputAdornment>
                            <IconButton
                              onClick={() => {
                                setCustomer(true);
                                handleClickOpen();
                              }}
                            >
                              <ViewListOutlinedIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={1.5}>
                    <FormControl fullWidth size="small" required>
                      <InputLabel id="demo-select-small-label">
                        Status{" "}
                      </InputLabel>
                      <Select
                        labelId="demo-select-small-label"
                        id="demo-select-small"
                        label="Status"
                        defaultValue={10}
                      >
                        <MenuItem value={10}>Process</MenuItem>
                        <MenuItem value={20}>Approval</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={1.5}>
                    <DateCalander title="Appoinment Date" />
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={0.5} display="flex">
                    <Button
                      fullWidth
                      sx={buttonStyle.root}
                      onClick={() => navigate("/estimate")}
                    >
                      Save
                    </Button>
                    &nbsp;
                    <Button
                      fullWidth
                      sx={buttonStyle.root}
                      onClick={() => navigate("/Estimate_Bill")}
                    >
                      Print
                    </Button>
                  </Grid>
                </Grid>
              </Box>
              <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle
                  id="alert-dialog-title"
                  sx={{ fontSize: "15px", textAlign: "center" }}
                >
                  {customer ? "Customer Details" : "Vehicle Details"}
                </DialogTitle>
                <DialogContent>
                  {customer && <Cutomer enquiryDetail={enquiryDetail} />}
                  {vehicle && <Vehicle vehicleDetail={vehicleDetail} />}
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose}>Close</Button>
                </DialogActions>
              </Dialog>
            </Grid>
            <Grid item xs={12}>
              <Box mt={1}>
                <Grid container spacing={1}>
                  <Grid item xs={12} sm={12} md={3} p={1}>
                    <HeaderBox title="Task Category" />
                    <Paper sx={{ p: 1, mt: 1 }}>
                      <Box
                        sx={{
                          border: "2px solid",
                          borderColor: "rgb(223, 218, 218)",
                          boxShadow: "2px 2px 2px rgba(0, 0, 0, 0.25)",
                        }}
                      >
                        {!fChild && !sChild && (
                          <ParentLabour
                            labour={labour}
                            handleParent={handleParent}
                          />
                        )}
                        {fChild && !sChild && (
                          <FirstChild
                            children={firstChild}
                            parentName={parentName}
                            setFChild={setFChild}
                            setSChild={setSChild}
                            handleChild={handleChild}
                            handleToggle={handleToggle}
                            checked={checked}
                          />
                        )}
                        {sChild && !fChild && (
                          <SecondChild
                            children={secondChildren}
                            parentName={parentName}
                            setFChild={setFChild}
                            setSChild={setSChild}
                            handleToggle={handleToggle}
                            checked={checked}
                          />
                        )}
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid item xs={12} sm={12} md={9} p={1}>
                    <HeaderBox title="Estimate Calculation" />
                    <Paper sx={{ p: 1, mt: 1 }}>
                      <Box>
                        <AddLabourTask
                          rows={rows}
                          setRows={setRows}
                          addRow={addRow}
                          handleDelete={handleDelete}
                          deleteRowParts={deleteRowParts}
                        />
                      </Box>
                      <Box mt={2}>
                        <AddPartsTask
                          rowsPart={rowsPart}
                          setRowsPart={setRowsPart}
                          addRowParts={addRowParts}
                          deleteRowParts={deleteRowParts}
                        />
                      </Box>
                      <Box mt={2}>
                        <Grid container spacing={1}>
                          <Grid item xs={5}>
                            <TextField
                              id="outlined-multiline-static"
                              label="Suggestions"
                              multiline
                              rows={5}
                              fullWidth
                            />
                          </Grid>

                          <Grid item xs={7}>
                            <Box>
                              <Grid container spacing={1}>
                                <Grid
                                  item
                                  xs={12}
                                  display="flex"
                                  justifyContent="space-between"
                                >
                                  <Typography>Taxable Amount</Typography>
                                  <Typography>
                                    {calculateTotalAmount().toFixed(2)}
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  display="flex"
                                  justifyContent="space-between"
                                >
                                  <Box
                                    display="flex"
                                    justifyContent="space-between"
                                  >
                                    <Typography>Discount %</Typography>
                                    &nbsp;&nbsp;
                                    <TextField
                                      // fullWidth
                                      style={{ width: "60px" }}
                                      InputProps={{
                                        style: { height: "20px" },
                                      }}
                                      size="small"
                                      variant="outlined"
                                      required
                                      name="estimateDate"
                                      value={disc}
                                      onChange={(e) => setDisc(e.target.value)}
                                    />
                                  </Box>

                                  <Typography>
                                    {(
                                      calculateTotalAmount() *
                                      (disc / 100)
                                    ).toFixed(2)}
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  display="flex"
                                  justifyContent="space-between"
                                >
                                  <Typography>Discounted Amount</Typography>
                                  <Typography>
                                    {calculateDiscountedAmount().toFixed(2)}
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  display="flex"
                                  justifyContent="space-between"
                                >
                                  <Box
                                    display="flex"
                                    justifyContent="space-between"
                                  >
                                    <Typography>VAT %</Typography>&nbsp;&nbsp;
                                    <TextField
                                      // fullWidth
                                      style={{ width: "60px" }}
                                      InputProps={{
                                        style: { height: "20px" },
                                      }}
                                      size="small"
                                      variant="outlined"
                                      required
                                      name="estimateDate"
                                      value={vat}
                                      onChange={(e) => setVat(e.target.value)}
                                    />
                                  </Box>
                                  <Typography>
                                    {calculateVATAmount().toFixed(2)}
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  display="flex"
                                  justifyContent="space-between"
                                >
                                  <Typography>Net Total</Typography>
                                  <Typography>
                                    {calculateNetTotal().toFixed(2)}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            
          </Grid>
        </form>
      </Box>
    );
}

export default EstimateTask